<footer>
  <div
    class="hmn-plain-footer hmn-row__space hmn-width__full"
    [ngClass]="background">
    <h6 class="hmn-color__accent">HUMANLY S.R.L.</h6>

    <h6 class="hmn-color__accent-contrast">VAT: 18763772991</h6>
  </div>
</footer>
